import React from "react";
import TextareaInput from "./TextareaInput";
import { CartAction } from "store/actions";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import C from "Constants";
import SpecialNote from "./item/SpecialNote";

function PickupVehicleInfo({ className="px-4" }) {
  const dispatch = useDispatch();
  const { pickupVehicleInfo } = useSelector((state) => state.cart);
  const { selectedStore } = useSelector((state) => state.store);
  const { orderType } = useSelector((state) => state.AppReducer);

  if (!selectedStore?.vehicleInfoForPickup?.isActive) return null;
  if (orderType?.EN?.name !== C.SERVICE_TYPE.PICKUP) return null;
  return (
    <div className={className}>
      <SpecialNote value={pickupVehicleInfo} onChange={(e) =>
          dispatch(CartAction.setPickupVehicleInfo(e.target.value))
        } label="Add vehicle info" placeholder="e.g. plate 18692, color black, brand lexus" />
      
    </div>
  );
}

export default PickupVehicleInfo;
